export const SCENARIOS = {
  feedContainer: 'scenario-feed-container',
  card: (id) => `scenario-card-${id}`,
  cardTitle: (id) => `scenario-card-title-${id}`,
  voteBiasButton: (id) => `scenario-vote-bias-button-${id}`,
  voteNotBiasButton: (id) => `scenario-vote-not-bias-button-${id}`,
  categoryFilter: 'scenario-category-filter',
  submitButton: 'scenario-submit-nav-button',
  emptyState: 'scenario-feed-empty-state',
};

export const SUBMIT_SCENARIO = {
  titleInput: 'submit-scenario-title-input',
  contentInput: 'submit-scenario-content-input',
  categorySelect: 'submit-scenario-category-select',
  categoryOption: (key) => `submit-scenario-category-option-${key}`,
  mediaUploadInput: 'submit-scenario-media-upload-input',
  submitButton: 'submit-scenario-submit-button',
  violentWarning: 'submit-scenario-violent-warning',
  goToBernButton: 'submit-scenario-go-to-bern-button',
};
